import { useEffect, useState } from "react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Card } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { api, formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";

function toSchedule(loan) {
  if (!loan?.schedule) return [];
  return loan.schedule;
}

export default function ActiveLoans() {
  const [loans, setLoans] = useState([]);
  useEffect(() => {
    api.get("/loans").then(async (r) => {
      const actives = r.data.filter((l) => ["approved","disbursed","active"].includes(l.status));
      const detailed = await Promise.all(actives.map((l) => api.get(`/loans/${l.id}`).then((rr) => rr.data)));
      setLoans(detailed);
    }).catch(() => {});
  }, []);

  const pay = async (loanId, amount) => {
    try {
      await api.post(`/loans/${loanId}/repay`, { loan_id: loanId, amount });
      toast.success("Payment recorded (demo)");
    } catch (e) { toast.error(formatApiErrorDetail(e?.response?.data?.detail) || "Failed"); }
  };

  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Active</div>
          <h1 className="font-display text-3xl mt-2">Active loans</h1>
        </div>

        {loans.length === 0 && <Card className="p-8 text-sm text-muted-foreground">No active loans right now.</Card>}

        {loans.map((l) => (
          <Card key={l.id} className="p-6">
            <div className="flex flex-col md:flex-row justify-between md:items-center gap-3 mb-4">
              <div>
                <div className="text-xs uppercase tracking-widest text-primary font-semibold capitalize">{l.loan_type.replace("_"," ")}</div>
                <div className="font-display text-xl mt-1">₹{Number(l.approved_amount || l.amount).toLocaleString("en-IN")} · {l.tenure_months} mo · {l.interest_rate}%</div>
              </div>
              <Button onClick={() => pay(l.id, (toSchedule(l)[0]?.emi || 0))} className="brand-gradient text-white rounded-full" data-testid={`pay-emi-${l.id}`}>Pay next EMI</Button>
            </div>
            <div className="overflow-x-auto">
              <Table>
                <TableHeader>
                  <TableRow>
                    <TableHead>#</TableHead><TableHead>Due date</TableHead><TableHead>EMI</TableHead><TableHead>Principal</TableHead><TableHead>Interest</TableHead><TableHead>Balance</TableHead><TableHead>Status</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {toSchedule(l).map((s) => (
                    <TableRow key={s.installment}>
                      <TableCell>{s.installment}</TableCell>
                      <TableCell>{s.due_date}</TableCell>
                      <TableCell>₹{s.emi.toLocaleString("en-IN")}</TableCell>
                      <TableCell>₹{s.principal.toLocaleString("en-IN")}</TableCell>
                      <TableCell>₹{s.interest.toLocaleString("en-IN")}</TableCell>
                      <TableCell>₹{s.balance.toLocaleString("en-IN")}</TableCell>
                      <TableCell><span className="text-xs px-2 py-1 rounded-full bg-muted">{s.status}</span></TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          </Card>
        ))}
      </div>
    </DashboardLayout>
  );
}
